import React from 'react';
import { NavLink } from 'react-router-dom';
import { UilBriefcase } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';

export const getBorrowersMenuItems = (basePath, toggleCollapsed, topMenu) => {
  const { t } = useTranslation();
  return [
    {
      key: 'borrowers',
      label: t('Borrowers'),
      icon: !topMenu && <UilBriefcase size={20} />,
      children: [
        {
          key: 'borrowers-add',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/borrower/registration`}>
              {t('Add Borrower')}
            </NavLink>
          ),
        },
        {
          key: 'borrowers-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/borrower/list`}>
              {t('Borrowers List')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'projects',
      label: t('Projects'),
      icon: !topMenu && <UilBriefcase size={20} />,
      children: [
        {
          key: 'projects-add',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/project/registration`}>
              {t('New Project')}
            </NavLink>
          ),
        },
        {
          key: 'projects-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/project/list`}>
              {t('Projects List')}
            </NavLink>
          ),
        },
      ],
    },
    // {
    //   key: 'member',
    //   label: t('Member'),
    //   icon: !topMenu && <UilBriefcase size={20} />,
    //   children: [
    //     {
    //       key: 'member-add',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/member/registration`}>
    //           {t('Add Member')}
    //         </NavLink>
    //       ),
    //     },
    //     {
    //       key: 'member-list',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/member/list`}>
    //           {t('Member List')}
    //         </NavLink>
    //       ),
    //     },
    //   ],
    // },
  ];
};
